/**
 * Play a short notification sound (two-tone chime) using Web Audio API.
 * No external audio file required. Call when a new order appears for restaurant/store/driver.
 */
export function playNewOrderSound() {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const playTone = (frequency, startTime, duration) => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.frequency.value = frequency;
      oscillator.type = 'sine';
      gainNode.gain.setValueAtTime(0.15, startTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    };
    playTone(523.25, 0, 0.15);       // C5
    playTone(659.25, 0.2, 0.2);      // E5
  } catch (e) {
    console.warn('Notification sound failed:', e);
  }
}
